import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    // {
    //     path: '',
    //     redirect: { name: 'view5', path: '/' }
    // },
    {
        name: 'view1',
        component: () => import('../view/view1'),
        meta: {
            keepAlive: false
        }
    },
    // {
    //     name: 'view2',
    //     component: () => import('../view/view4'),
    //     meta: {
    //         keepAlive: false
    //     }
    // },
    {
        name: 'view3',
        component: () => import('../view/view3'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'login',
        component: () => import('../view/login'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'sha',
        component: () => import('../view/sha'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view5',
        path: '/view5',  // 添加 robotId 参数
        component: () => import('../view/view5'),
        meta: {keepAlive: false},
    },
    {
        name: 'view6',
        path: '/view6',  // 添加 robotId 参数
        component: () => import('../view/view6'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view7',
        path: '/view7',  // 添加 robotId 参数
        component: () => import('../view/view7'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view8',
        component: () => import('../view/view8'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view9',
        component: () => import('../view/view9'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view20',
        component: () => import('../view/view20'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view10',
        component: () => import('../view/view10'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view11',
        path: '/view11',  // 添加 robotId 参数
        component: () => import('../view/view11'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view12',
        path: '/view12',  // 添加 robotId 参数
        component: () => import('../view/view12'),
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'view13',
        component: () => import('../view/view13'),
        meta: {
            keepAlive: false
        }
    },
  {
    path: '/',
    component: () => import('../view/HomePage'),
    meta: {
      keepAlive: false
    }
  },
    // {
    //     name: 'ceshi1',
    //     component: () => import('../view/ceshi1'),
    //     meta: {
    //         keepAlive: false
    //     }
    // },
    // {
    //     name: 'ceshi2',
    //     component: () => import('../view/ceshi2'),
    //     meta: {
    //         keepAlive: false
    //     }
    // },{
    //     name: 'ceshi3',
    //     component: () => import('../view/ceshi3'),
    //     meta: {
    //         keepAlive: false
    //     }
    // },


];
// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

// const router = new Router({ mode: 'history', base: '/account/', routes: [...login, ...routes] });

// const router = new Router({ mode: 'history', base: '/platform/', routes: [...routes] });
const router = new Router({
  mode: 'history',
  routes: [...routes]
});

router.beforeEach((to, from, next) => {
  // 默认标题
  document.title = "三代机器人大屏";
  next();
});

export {
    router
};
